"use client";
import { useMouseMovement } from "@/app/[lang]/MouseMovementContext";
import React from "react";
import { MSProductWithFullDetail, MSProductWithFullDetailWithVaraintPreset } from "@/util/query/product-query";
import dynamic from "next/dynamic";
const ProductHeaderDetail = dynamic(() => import("./product-header-detail"), { ssr: false });
import StarRating from "../controls/start-rating";
import { Forward } from "lucide-react";
import ColorStyleContext from "@/lib/providers/color-style-privider";
import { useContext } from "react";
import { makeBaseComponentId } from "@/util/make-component-id";

interface Props {
    product: MSProductWithFullDetailWithVaraintPreset & { shopCurrency: string };
    promotionVariantProduct?: MSProductWithFullDetail;
    startVariantId?: string | null | undefined;
    onSelectedVariantIndex?: (index: number) => void;
    level: string;
    text: { [key: string]: string };
    loc: string;
    productContactForm: JSX.Element | null;
    priorityContent?: boolean;
    enableCompareButton?: boolean;
    radiusStyle: any;
}

const ProductHeaderDetailLoader = ({
    product,
    promotionVariantProduct,
    startVariantId,
    onSelectedVariantIndex,
    level,
    text,
    loc,
    productContactForm,
    priorityContent,
    enableCompareButton = false,
    radiusStyle,
}: Props) => {
    const { hasMouseMoved } = useMouseMovement();
    const colorStyle = useContext(ColorStyleContext);

    return hasMouseMoved || priorityContent ? (
        <ProductHeaderDetail
            product={product}
            promotionVariantProduct={promotionVariantProduct}
            startVariantId={startVariantId}
            onSelectedVariantIndex={onSelectedVariantIndex}
            level={level}
            text={text}
            loc={loc}
            productContactForm={productContactForm}
            enableCompareButton={enableCompareButton}
            radiusStyle={radiusStyle}
        />
    ) : (
        <section>
            <div
                className="flex flex-col gap-5"
                id={makeBaseComponentId("product-header-detail-loader", `product-header-detail-loader`)}>
                <div
                    className="flex flex-col gap-5"
                    id={makeBaseComponentId(
                        "product-header-detail-loader-title",
                        `product-header-detail-loader-title`,
                    )}>
                    <h1
                        className="text-2xl font-normal"
                        style={{ color: colorStyle?.headingMain || "#254b7c" }}
                        id={makeBaseComponentId(
                            "product-header-detail-loader-title-text",
                            `product-header-detail-loader-title-text`,
                        )}>
                        {product.attributes?.displayName ?? ""}
                    </h1>
                    <div
                        id={makeBaseComponentId(
                            "product-header-detail-loader-title-description",
                            `product-header-detail-loader-title-description`,
                        )}
                        className="font-light text-sm"
                        style={{ color: colorStyle?.text || "#3d3d3d" }}
                        dangerouslySetInnerHTML={{
                            __html: product.attributes?.description ?? "",
                        }}
                    />
                </div>
                <div
                    className="flex justify-between items-center"
                    id={makeBaseComponentId(
                        "product-header-detail-loader-rating",
                        `product-header-detail-loader-rating`,
                    )}>
                    <StarRating score={product.averageRating ?? 0} />
                    <div className="flex gap-5 h-10">
                        <div className="inline-flex items-center justify-center whitespace-nowrap ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 text-[16px] font-normal rounded-full bg-grayc4 text-c4 hover:text-c2 h-10 w-10 cursor-pointer">
                            <Forward size={20} />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ProductHeaderDetailLoader;
